// CandidatePagination.jsx
import { Pagination } from "@mui/material";
import React from "react";

const CandidatePagination = ({ totalPages, currentPage, onPageChange }) => {
  return (
    <Pagination
      count={totalPages || 0}
      page={currentPage}
      onChange={(_, page) => onPageChange(page - 1)}
      color="primary"
      size="large"
      sx={{
        "& .MuiPaginationItem-root": {
          backgroundColor: "white",
          "&:hover": { backgroundColor: "#e3f0fe" },
        },
        "& .Mui-selected": {
          backgroundColor: "#1976d2 !important",
          color: "white",
        },
      }}
    />
  );
};

export default CandidatePagination;